import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show } from '@/reducers/Modal'
import {MessageNotificationView} from "@/views/messages/MessageNotificationView";


class MessageController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }
  
  render() {
      const {key} = this.props;
      return (
          <MessageNotificationView key={key} {...this.props}/>
      );
      
  }
}
const MessageControllerInit = (props) => {
  return (
    <MessageController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {chat, Notification} = state;
  return {
        messages: chat.messages,
        Notification
  };
}

export default connect(mapStateToProps)(MessageControllerInit);  